import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Input from '../../../shared/forms/input/input.component';
import FormControl from '../../../shared/forms/formControl.component';

class ParamInput extends PureComponent {
  static propTypes = {
    updateQueryParams: PropTypes.func.isRequired,
    queryParam: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    mappingName: PropTypes.string.isRequired,
  };

  changeProperty = event => {
    this.props.updateQueryParams({ [this.props.name]: event.target.value });
  };

  render() {
    const {
      queryParam,
      mappingName,
      name,
    } = this.props;

    return (
      <FormControl
        onChange={this.changeProperty}
        name={name}
        label={mappingName}
        value={queryParam}
        horizontal
      >
        <Input
          type="text"
        />
      </FormControl>
    );
  }
}

export default ParamInput;
